import { BUTTON_VARIANTS } from 'ui/button';
import { BannerVariants } from './types';

export const getCloseBtnVariant = (variant: BannerVariants): BUTTON_VARIANTS => {
  switch (variant) {
    case BannerVariants.INFO:
      return BUTTON_VARIANTS.GHOSTINFO;
    case BannerVariants.WARNING:
      return BUTTON_VARIANTS.GHOSTWARNING;
    case BannerVariants.ERROR:
      return BUTTON_VARIANTS.GHOSTERROR;
    case BannerVariants.NEUTRAL:
      return BUTTON_VARIANTS.GHOST;
    default:
      return BUTTON_VARIANTS.GHOSTSUCCESS;
  }
};
